import { render, staticRenderFns } from "./Notfound.vue?vue&type=template&id=8be1d2f8"
import script from "./Notfound.vue?vue&type=script&lang=js"
export * from "./Notfound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports